// Digits plus a letter suffix (e.g. 47280567L, 54375933LN, 6000623908SN).
const INSIGHT_TMS_LOAD_ID_PATTERN = /\b\d+[A-Z]+\b/i;

// Extracts the first Insight TMS load id from raw text (form field or email ref).
// Supports comma-separated lists by returning the first match.
export function normalizeInsightTMSLoadId(raw: string): string {
  const loadId = raw.trim().match(INSIGHT_TMS_LOAD_ID_PATTERN)?.[0];

  return loadId?.toUpperCase() ?? '';
}
